import { supabase } from 'Services/supabaseClient'

export const subscribeToPersonalChatRealtime = ({ channelName, userId, onMessage }) => {
  if (!userId) {
    return () => {}
  }

  const channel = supabase
    .channel(channelName)
    .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'personal_messages' }, async (event) => {
      if (event?.new?.sender_id === userId) return

      const chatId = event?.new?.chat_id

      if (!chatId) return

      let senderName = ''
      let senderAvatar = ''

      try {
        const [{ data: chatRecord }, { data: sender }] = await Promise.all([supabase.from('personal_chats').select('user1_id, user2_id').eq('id', chatId).single(), supabase.from('users').select('first_name, last_name, users_flag_url').eq('userid', event?.new?.sender_id).single()])

        if (!chatRecord) return

        const isParticipant = String(chatRecord.user1_id) === String(userId) || String(chatRecord.user2_id) === String(userId)

        if (!isParticipant) return

        if (sender) {
          const fullName = `${sender.first_name || ''} ${sender.last_name || ''}`.trim()

          senderName = fullName || 'User'
          senderAvatar = sender.users_flag_url || ''
        }
      } catch {
        return
      }

      if (typeof onMessage === 'function') {
        onMessage({
          event,
          senderName,
          senderAvatar
        })
      }
    })
    .subscribe()

  return () => {
    supabase.removeChannel(channel)
  }
}

export const subscribeToCommunityChatRealtime = ({ channelName, userId, onMessage }) => {
  if (!userId) {
    return () => {}
  }

  const channel = supabase
    .channel(channelName)
    .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'messages' }, async (event) => {
      if (event?.new?.userid === userId) return

      let senderName = ''
      let senderAvatar = ''
      const communityName = event?.new?.community_name || ''
      const communityLogo = event?.new?.community_url || ''

      try {
        const { data: sender } = await supabase.from('users').select('first_name, last_name, users_flag_url').eq('userid', event?.new?.userid).single()

        if (sender) {
          const fullName = `${sender.first_name || ''} ${sender.last_name || ''}`.trim()

          senderName = fullName || 'User'
          senderAvatar = sender.users_flag_url || ''
        }
      } catch {
        // console.log()
      }

      if (typeof onMessage === 'function') {
        onMessage({
          event,
          senderName,
          senderAvatar,
          communityName,
          communityLogo
        })
      }
    })
    .subscribe()

  return () => {
    supabase.removeChannel(channel)
  }
}
